<template>
  <!-- Main Content -->
  <div id="content">
    <!-- Begin Page Content -->
    <div class="container-fluid">
      <!-- Page Heading -->
      <h1 class="h3 mb-2 text-gray-800" v-if="!isEdit" >Crear Examen</h1>
      <h1 class="h3 mb-2 text-gray-800" v-if="isEdit">Editar Examen</h1>
      <!-- DataTales Example -->
      <div class="card shadow mb-4">

        <div class="card-body">
          <b-form @submit="onSubmit" @reset="onReset" v-if="show">
            <div class="row">

              <div class="col-6">
                <b-form-group id="input-group-3" label="Título:" label-for="input-category">
                  <b-form-group label-for="keyInput" >
                    <b-form-input id="keyInput"  v-model="form.title" required ></b-form-input>
                  </b-form-group>
                </b-form-group>
              </div>
              <div class="col-6">
                <b-form-group label="Descripción" label-for="input-category" >
                  <b-form-input id="keyInput"  v-model="form.description" required ></b-form-input>
                </b-form-group>
              </div>

              <div class="col-6">
                <b-form-group label="Inicio de fechas" label-for="keyInput">
                  <date-pick
                    class="endDate2"
                    v-model="form.startDate"
                    required
                    :pickTime="true"
                    :format="'YYYY-MM-DD HH:mm'"
                  ></date-pick>
                </b-form-group>
              </div>

              <div class="col-6">
                <b-form-group label="Fin de fecha" label-for="keyInput">
                  <date-pick
                    class="endDate2"
                    v-model="form.endDate"
                    required
                    :pickTime="true"
                    :format="'YYYY-MM-DD HH:mm'"
                  ></date-pick>
                </b-form-group>
              </div>

              <div class="col-6">
                <b-form-group label="Mínimo de preguntas" label-for="keyInput">
                  <b-form-input
                    id="keyInput"
                    v-model="form.minQuestions"
                    required
                    @input="handleInputChange()"
                    type="number"
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="col-6">
                <b-form-group label="Máximo de preguntas" label-for="keyInput">
                  <b-form-input
                    id="keyInput"
                    v-model="form.maxQuestions"
                    required
                    @input="handleInputChange()"
                    inputmode="numeric"
                    type="number"
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="col-6">
                <b-form-group label="Duración (en minutos)" label-for="keyInput">
                  <b-form-input id="keyInput" v-model="form.duration" required type="number" @input="handleInputChange()"></b-form-input>
                </b-form-group>
              </div>

              <div class="col-6">
                <input
                  id="checkAnswers"
                  type="checkbox"
                  v-model="form.checkAnswers"
                  :class="{ 'checked': form.checkAnswers }"
                />
                <label class="span-diagnostic" for="checkAnswers">Poder revisar respuestas</label>
              </div>

              <div class="col-6">
                <input
                  id="seeResult"
                  type="checkbox"
                  v-model="form.seeResult"
                  :class="{ 'checked': form.seeResult }"
                />
                <label class="span-diagnostic" for="seeResult">Ver resultados</label>
              </div>

              <div class="col-6">
                <input
                  id="isPremium"
                  type="checkbox"
                  v-model="form.isPremium"
                  :class="{ 'checked': form.isPremium }"
                />
                <label class="span-diagnostic" for="isPremium">Es examen premium</label>
              </div>

            </div>

            <b-button type="submit" variant="primary">Guardar</b-button>
          </b-form>
        </div>
      </div>
    </div>


    <!-- add Questions-->
    <div class="container-fluid" v-if="isEdit">
      <!-- DataTales Example -->
      <div class="card shadow mb-4">
        <div id="app" class="container">
          <div class="div-lessons">
            <h3>Preguntas:</h3>
            <div>
              <button class="btn btn-primary"  @click="showModal()">
                <font-awesome-icon icon="fas fa-plus-square" />&nbsp;Agregar Preguntas
              </button>
              <button class="btn btn-primary ml-2" @click="showModalAddQuestionsRandom()">
                <font-awesome-icon icon="fas fa-plus-square" />&nbsp;Agregar Preguntas Aleatoriamente
              </button>
            </div>
          </div>

          <br>
          <br>

          <table class="table">
            <thead>
              <tr >
                <th>Nombre unico</th>
              </tr>
            </thead>

            <tbody v-for="question in examQuestions?.questions" :key="question.id">
              <tr >
                <td>{{question.uniqueName}}</td>
                <td></td>
                <td>
                  <button class="btn btn-secondary p-2 d-block w-100 ml-2"
                  v-on:click="deleteQuestion(question.id)">
                        Eliminar
                  </button>
                </td>
              </tr>
            </tbody>

            <tbody >
              <tr >
                <td colspan="2" class="td-nhd">No hay datos</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <QuestionAdd ref="quesionAddComponent" @saveQuestion="saveQuestion"/>
      <QuestionsAddRandom ref="quesionAddRandomComponent" :parent-model="module"/>

    </div>
     <!-- /add Questions-->

     <!-- add Simulacrums-->
    <div class="container-fluid" v-if="isEdit">
      <!-- DataTales Example -->
      <div class="card shadow mb-4">
      <div id="app" class="container">
        <div class="div-lessons">
          <h3>Simulacros:</h3>
          <button class="btn btn-primary"  @click="showModal2()">
            <font-awesome-icon icon="fas fa-plus-square" />&nbsp;Agregar Simulacros
          </button>
        </div>

        <br>
        <br>

        <table class="table">
          <thead>
            <tr >
              <th>Titulo</th>
              <th>Duración</th>
            </tr>
          </thead>

          <tbody v-for="simulacruExams in simulacrumsExams.simulacrums" :key="simulacruExams.id">
            <tr >
              <td>{{ simulacruExams.title}}</td>
              <td>{{ simulacruExams.duration}}</td>
              <td>
                <button class="btn btn-secondary p-2 d-block w-100 ml-2"
                 v-on:click="deleteSimulacrum(simulacruExams.id)">
                      Eliminar
                </button>
              </td>
            </tr>
          </tbody>

          <tbody>
            <tr >
              <td colspan="2" class="td-nhd">No hay datos</td>
            </tr>
          </tbody>

        </table>
      </div>
    </div>

    <b-modal no-close-on-backdrop ref="my-modal2" size="xl" hide-footer title="Simulacros" v-on:hide="onModalHide">

      <div class="lessons-model">
        <input type="text" class="form-control bg-light border-0 small" placeholder="Buscar por titulo"
        aria-label="Search" aria-describedby="basic-addon2" v-model="searchSimulacrums"  v-on:keyup="loadSimulacrums">
      </div>

      <div class="lessons-model">
        <table class="table">
          <thead>
            <tr>
              <th>Titulo</th>
              <th>Duración</th>
            </tr>
          </thead>
          <tbody v-for="(simulacrum, index) in simulacrumsItems" :key="index">
            <tr>
              <td>{{ simulacrum.title }}</td>
              <td>{{ simulacrum.duration }}</td>
              <td><div class="col col-sm-6 col-md-6 col-lg-6 text-center">
                <b-button class="btn btn-secondary" v-on:click="saveSimulacrum(simulacrum.id, )"
                block>Agregar</b-button>
              </div></td>
            </tr>
          </tbody>

          <tbody v-if="simulacrumsItems.length === 0">
            <tr >
              <td colspan="2" class="td-nhd">No hay datos</td>
            </tr>
          </tbody>
        </table>
      </div>

    </b-modal>

    </div>
     <!-- /add Simulacrums-->

  </div>
</template>

<script>
import axios from "axios";
import router from "../../../../router";
import QuestionAdd from "../Questions/QuestionsAdd.vue"
import QuestionsAddRandom from "../Questions/QuestionsAddRandom.vue"
import DatePick from "vue-date-pick";

export default {
  components: {
    DatePick,
    QuestionAdd,
    QuestionsAddRandom
  },
  data() {
    return {
      form: {
        description: '',
        title: '',
        maxQuestions: '',
        minQuestions: '',
        duration: '',
        endDate: '',
        startDate: '',
        key: '',
        checkAnswers: false,
        seeResult: false,
        isPremium: false,
      },

      show: true,
      examId: null,
      isEdit: false,
      examsQuestions: [],
      searchSimulacrums: "",
      simulacrumsItems: [],
      simulacrumsExams: [],
      examQuestions: [],
      module: 'exams'
    }
  },
  methods: {
    handleInputChange() {
      if (this.form.maxQuestions < 0) {
        this.form.maxQuestions = Math.abs(this.form.maxQuestions);
      }
      if (this.form.minQuestions < 0) {
        this.form.minQuestions = Math.abs(this.form.minQuestions);
      }
      if (this.form.duration < 0) {
        this.form.duration = Math.abs(this.form.duration);
      }
    },
    loadSimulacrums() {
      axios
        .get(import.meta.env.VITE_API_BASE_URL + "/api/simulacrums/getSimulacrumsListforAdd/", {
          params: {
            search: this.searchSimulacrums
          },
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((response) => {
          if (response.data) {
            response.data;
          }
          this.simulacrumsItems = response.data;

        })
        .catch((err) => {
          console.log(err.message);;
        });
    },
    showModal() {
      this.$refs['quesionAddComponent'].showModal();
    },
    showModalAddQuestionsRandom() {
      this.$refs['quesionAddRandomComponent'].showModal();
    },
    showModal2() {
      this.$refs['my-modal2'].show();
    },
    onModalHide() {
      this.searchQuestions= '';
      this.examsQuestions= '';
      this.searchSimulacrums= '';
      this.simulacrumsItems= '';
    },
    deleteQuestion(id) {
      if(!confirm("¿Estás seguro que deseas eliminar esta Pregunta?")){
        return
      }
      let loader = this.$loading.show({});
      axios
        .delete(
          import.meta.env.VITE_API_BASE_URL + "/api/exams/" + this.examId + "/questions/" + id,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          console.log(response);
          loader.hide();
          this.$router.go();
        })
        .catch((err) => {
          console.log(err.message);
          loader.hide();
        });
    },
    deleteSimulacrum(id) {
      if(!confirm("¿Estás seguro que deseas eliminar este simulacro?")){
        return
      }
      let loader = this.$loading.show({});
      axios
        .delete(
          import.meta.env.VITE_API_BASE_URL + "/api/exams/" + this.examId + "/simuLacrums/" + id,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          console.log(response);
          loader.hide();
          this.$router.go();
        })
        .catch((err) => {
          console.log(err.message);
          loader.hide();
        });
    },
    saveQuestion(questionId) {

      this.examId = this.$route.params.id;
      let examId = parseInt(this.examId);
      axios.post(import.meta.env.VITE_API_BASE_URL + "/api/exams/saveQuestion", {
        'examId': examId, 'questionId': questionId
      }, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        }
      }).then((result) => {
        this.$toastr.defaultTimeout = 2000; // default timeout : 5000
        this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
        this.$toastr.s(
          "Pregunta Guardado."
        );
        console.log(result);
        this.$router.go();

      }).catch((err) => {
        if (err.response.data === 'duplicated') {
          this.$toastr.defaultTimeout = 2000; // default timeout : 5000
          this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
          this.$toastr.e(
            "Error al crear, Ya se ha agregado esta pregunta antes"
          );
          console.log(err.message);
        } else if (err.response.data === 'maxReached') {
          this.$toastr.defaultTimeout = 2000; // default timeout : 5000
          this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
          this.$toastr.e(
            "Maximo de preguntas alcanzado"
          );
          console.log(err.message);
        } else {
          this.$toastr.defaultTimeout = 2000; // default timeout : 5000
          this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
          this.$toastr.e(
            "Error al crear"
          );
          console.log(err.message);
        }
      });
    },
    saveSimulacrum(simulacrumId) {

    this.examId = this.$route.params.id;
    var examId = parseInt(this.examId);
    axios.post(import.meta.env.VITE_API_BASE_URL + "/api/exams/saveSimulacrum", {
      'examId': examId  , 'simulacrumId': simulacrumId
    }, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        }}).then((result) => {
        this.$toastr.defaultTimeout = 50000; // default timeout : 5000
        this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
        this.$toastr.s(
          "Simulacro Guardado."
        );
        console.log(result);
        setTimeout(this.$router.go(), 3000);
      }).catch((err) => {
        if (err.response.data === 'duplicated') {
          this.$toastr.defaultTimeout = 2000; // default timeout : 5000
          this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
          this.$toastr.e(
            "Error al crear, Ya se ha agregado este simulacro antes"
          );
          console.log(err.message);
        } else {
          this.$toastr.defaultTimeout = 2000; // default timeout : 5000
          this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
          this.$toastr.e(
          "Error al crear"
          );
          console.log(err.message);
        }
      });
    },
    populateSelectExams() {
      this.exams = [];
      this.examsResponse = [];
      if (this.form.module) {
        let relatedExams = this.modulesResponse.find(obj => obj.id === this.form.module).exams;
        this.examsResponse = relatedExams;
        this.exams.push({text: 'Selecciona un examen.', value: null})

        for (let item of relatedExams) {
          console.log(item)
          this.exams.push({text: item.description, value: item.id})
        }
      }
    },
    onSubmit(event) {
      this.$toastr.defaultTimeout = 2000; // default timeout : 5000
      this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
      event.preventDefault();
      if (!this.form.endDate || !this.form.startDate) {
        this.$toastr.defaultTimeout = 2000; // default timeout : 5000
        this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
        this.$toastr.e("Falta el campo de fecha de inicio o fecha  fin" );
        return;
      }
      this.form.checkAnswers = this.form.checkAnswers === true || this.form.checkAnswers === 'true';
      this.form.seeResult = this.form.seeResult === true || this.form.seeResult === 'true';
      this.form.isPremium = this.form.isPremium === true || this.form.isPremium === 'true';

      if (this.isEdit) {
        let loader = this.$loading.show({});

        axios.put(import.meta.env.VITE_API_BASE_URL + "/api/exams/edit/" + this.examId , this.form, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          }}).then(() => {
          this.$toastr.s(
            "Examen Editado."
          );
          loader.hide();
          router.push({ path: `/admin-panel/exams` });
        }).catch((err) => {
          loader.hide();
          console.log(err.message);
          this.$toasted.error("Error al editar el examen, posiblemente ya exista alguna con los mismos datos y estado.", {position: 'top-right', duration: 5000});
        });
      } else {
        let loader = this.$loading.show({});
        axios.post(import.meta.env.VITE_API_BASE_URL + "/api/exams/save", this.form, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          }}).then(() => {
          this.$toastr.s(
            "Examen Guardado."
          );
          loader.hide();
          router.push({ path: `/admin-panel/exams` });
        }).catch((err) => {
          loader.hide();
          console.log(err.message);
          this.$toasted.error("Error al crear el examen, posiblemente ya exista alguna con los mismos datos y estado.", {position: 'top-right', duration: 5000});
        });
      }
    },
    onReset(event) {
      event.preventDefault()
    },
  },
  mounted() {
    //this.loadSubexams();

    if (this.$route.params.id) {
      this.examId = this.$route.params.id;
      this.isEdit = true;
      let loader = this.$loading.show({});
      axios.get(
        import.meta.env.VITE_API_BASE_URL + "/api/exams/" + this.examId,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          }
        }
      )
      .then((response) => {
        this.form.title = response.data.title;
        this.form.description = response.data.description;
        this.form.duration = response.data.duration;
        this.form.maxQuestions = response.data.maxQuestions;
        this.form.minQuestions = response.data.minQuestions;
        this.form.startDate = response.data.startDate.replace("T", " ").slice(0, -3);
        this.form.endDate = response.data.endDate.replace("T", " ").slice(0, -3);
        this.form.key = response.data.key;
        this.form.checkAnswers = response.data.checkAnswers;
        this.form.seeResult = response.data.seeResult;
        this.form.isPremium = response.data.isPremium || false;
        loader.hide();
        if(response.data === '') {
            console.log(response.data)
            this.lesson = [];
            this.examQuestions = [];
            this.simulacrumsExams = [];
            return;
          }
          let data= response.data;

          this.lesson = data;
          this.examQuestions = data;
          this.simulacrumsExams = data;
          loader.hide();
      }).catch((err) => {
        loader.hide();
        console.log(err.message);
      });
    }
  },
  beforeMount() {
    (function () {
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src =
        "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.2/MathJax.js?config=TeX-AMS_HTML";
      document.getElementsByTagName("head")[0].appendChild(script);
    })();
  },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


